export default __webpack_public_path__ + "assets/gambia-flag.png";